module.exports = __webpack_public_path__ + "img/remark4.cf3b2f11.png";